import { EmptyState, Loading } from '@/renderer/components/common';
import { useBookings } from '@hooks/accommodation';
import { useAppSelector } from '@hooks/useRedux';
import { selectAccommodationProperty } from '@store/accommodation';
import React from 'react';
import { useParams } from 'react-router-dom';
import { BookingActivityTimelineCard } from './BookingActivityTimelineCard';
import { BookingDetailPageHeader } from './BookingDetailPageHeader';
import { BookingFinancialsCard } from './BookingFinancialsCard';
import { BookingGuestCard } from './BookingGuestCard';
import { BookingOverviewCard } from './BookingOverviewCard';
import { BookingPaymentsCard } from './BookingPaymentsCard';
import { BookingRoomsCard } from './BookingRoomsCard';
import { BookingSidebarActions } from './BookingSidebarActions';
import { OutstandingRestaurantBillsCard } from './OutstandingRestaurantBillsCard';
import { OverstayAlert } from './OverstayAlert';

export const BookingDetailPage: React.FC = () => {
  const { bookingId } = useParams<{ bookingId: string }>();
  const property = useAppSelector(selectAccommodationProperty);
  const { data: bookings = [], isLoading } = useBookings(property?.id);

  const booking = bookings.find((b) => b.id === bookingId) ?? null;

  if (isLoading && !booking) {
    return <Loading title="Loading" description="Fetching Booking details" />;
  }

  if (!booking) {
    return (
      <EmptyState
        title="Booking not found"
        description="We couldn't find the booking."
      />
    );
  }

  return (
    <div className="space-y-5">
      <BookingDetailPageHeader />

      <div className="grid gap-5 lg:grid-cols-3">
        {/* ── Left: main detail ──────────────────────────────── */}
        <div className="space-y-4 lg:col-span-2">
          <OverstayAlert />
          <BookingGuestCard />
          <BookingOverviewCard />
          <BookingRoomsCard />
          <BookingFinancialsCard />
          <OutstandingRestaurantBillsCard />
        </div>

        {/* ── Right sidebar ──────────────────────────────────── */}
        <div className="space-y-4">
          <BookingSidebarActions />
          <BookingPaymentsCard />
          <BookingActivityTimelineCard />
        </div>
      </div>
    </div>
  );
};
export default BookingDetailPage;
